import { SvgIcon } from '@mui/material';
import { AutorenewIconStyles } from 'v3/shared/components/Button/MiniButton/styles';
import { CircularButtonStyles } from './styles';
import { CircularButtonProps } from './types';

export const CircularButton = ({
  handleClick,
  startIcon,
  backgroundColor,
  disabled = false,
  isLoading,
}: CircularButtonProps) => {
  return (
    <CircularButtonStyles
      onClick={disabled ? undefined : handleClick}
      variant={'circular'}
      $backgroundColor={backgroundColor}
      disabled={disabled}
    >
      {isLoading ? <AutorenewIconStyles /> : <SvgIcon component={startIcon} />}
    </CircularButtonStyles>
  );
};
